module.exports = __webpack_public_path__ + "static/media/ass.92108318.jpg";